import { createContext, useState } from 'react';
import { Message } from '../types';
import { Snackbar, Alert, AlertColor } from '@mui/material';

export const ThemeContext = createContext({
    tema : "padrão",
    setTema: (tema: string) => {}
});

export const ThemeProvider = ({ children }) => {
    const [tema, setTema] = useState<string>("padrão");

    return (
        <ThemeContext.Provider
            value = {{
                tema : tema,
                setTema: setTema
            }}
        >
            {children}

            
        </ThemeContext.Provider>
    );
};
